import React from 'react';
import ReactPlayer from 'react-player';

const VideoCard = ({
  title,
  url,
}: {
  title: string;
  url: string;
}) => {
  return (
    <div className="quick-reads-card">
      <ReactPlayer
        className="video-player"
        url={url}
        width="372px"
        height="209px"
        controls={true}
      />
      <p className="video-title">{title}</p>
    </div>
  );
};

export default VideoCard;
